const WorkData = [
  {
    title: 'covid tracking-app',
    desc: 'shows information about the all the covid related cases arround the world.',
    tech: ['React.js', 'HTML', 'CSS', 'TailwindCss', 'Javascript', 'Redux', 'Webpack'],
    gitlink: '//github.com/Alusp/covid19-data-tracking-app',
    site: '//covid-data-tracker-alusine.netlify.app/',
  },
  {
    title: 'WHO Assembly',
    desc: 'The Seventy-fifth World Health Assembly is the decision-making body of WHO',
    tech: ['HTML', 'CSS', 'JavaScript'],
    gitlink: '//github.com/Alusp/World-Health-Assembly',
    site: '//https://alusp.github.io/World-Health-Assembly/',
  },
  {
    title: 'math-magician',
    desc: 'Make simple calculations. Read a random math-related quote.',
    tech: ['React.js', 'Redux.js', 'HTML5', 'CSS', 'JavaScript'],
    gitlink: '//github.com/Alusp/math-magician',
    site: '//math-magical.netlify.app/',
  },
  {
    title: 'Leaderboard App',
    desc: 'An Application showing a list of game leaders and top scores',
    tech: ['HTML', 'CSS', 'JavaScript', 'Webpack'],
    gitlink: '//github.com/Alusp/leaderboard-app',
    site: '//leaderboardz.netlify.app/',
  },
  {
    title: 'Book Store App',
    desc: 'Book Store is a website that is used to Add, Display, Remove and Update Book',
    tech: ['React.js', 'Redux.js', 'TailwindCss', 'HTML5', 'JavaScript'],
    gitlink: '//github.com/Alusp/bookstore-with-react',
    site: '//alusine-jalloh-book-store.netlify.app/',
  },
  {
    title: 'Todo List App',
    desc: 'A Todo List structure approach that helps you create a list of things you want to do throughout the day.',
    tech: ['HTML', 'CSS', 'JavaScript', 'Webpack'],
    gitlink: '//github.com/Alusp/ToDolist',
    site: '//alusp.github.io/ToDolist/',
  },
];

export default WorkData;
